import React from 'react'
import styled from 'react-emotion'
import { Alert } from 'stylist'

const LoadErrorAlert = styled(Alert)`
  position: absolute;
  top: 49px;
  left: 50%;
  transform: translateX(-50%);
  width: 587px;
`

const LoadError = ({ loadError }) => (
  <React.Fragment>
    {loadError ? (
      <LoadErrorAlert
        kind="error"
        message="Unable to load your survey. Please try again or contact support."
      />
    ) : null}
  </React.Fragment>
)

export default LoadError



// WEBPACK FOOTER //
// ./src/components/Editor/Alerts/LoadError.js